import React from 'react';
export default function Account() {
    return <div className="st-container py-20"><h1 className="text-3xl font-display">Mi cuenta (Próximamente)</h1></div>;
}